"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import Link from "./webflow_modules/Basic/components/Link";

export function CommunityListResult({
  runtimeProps = {},
  text = "apartment name",
}) {
  return (
    <Link
      aria-label={"Open Resident Login Link"}
      block={"inline"}
      button={false}
      className={"apartment-list-result-link-com-copy"}
      options={{
        href: "#",
      }}
      {...runtimeProps}
    >
      <Block className={"apartment-list-result-container"} tag={"div"}>
        <Block className={"apartment-list-text-container"} tag={"div"}>
          <Block className={"text-block-17"} tag={"div"}>
            {text}
          </Block>
        </Block>
      </Block>
    </Link>
  );
}
